import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    createZone as createZoneApi,
    deleteZone as deleteZoneApi,
    getZone as getZoneApi,
    getZones as getZonesApi,
    updateZone as updateZoneApi,
} from "../../helpers/backend_helper";

export interface CreateZonePayload {
    [key: string]: unknown;
}

export interface UpdateZonePayload {
    zoneId: string | number;
    data: Record<string, unknown>;
}

export const getZones = createAsyncThunk(
    "Zones/getZones",
    async (_: void, { rejectWithValue }) => {
        try {
            const response = await getZonesApi();
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getZone = createAsyncThunk(
    "Zones/getZone",
    async (zoneId: string | number, { rejectWithValue }) => {
        try {
            const response = await getZoneApi(zoneId);
            return {
                zoneId,
                response,
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const createZone = createAsyncThunk(
    "Zones/createZone",
    async (data: CreateZonePayload, { rejectWithValue }) => {
        try {
            const response = await createZoneApi(data);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const updateZone = createAsyncThunk(
    "Zones/updateZone",
    async ({ zoneId, data }: UpdateZonePayload, { rejectWithValue }) => {
        try {
            const response = await updateZoneApi(zoneId, data);
            return {
                zoneId,
                response,
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const deleteZone = createAsyncThunk(
    "Zones/deleteZone",
    async (zoneId: string | number, { rejectWithValue }) => {
        try {
            const response = await deleteZoneApi(zoneId);
            return {
                zoneId,
                response,
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
